import React from 'react'
import PropTypes from 'prop-types'
import { DragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core'

const dropAnimationConfig = {
    sideEffects: defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0.4',
            },
        },
    }),
}

const SortableOverlay = ({ children }) => (
    <DragOverlay dropAnimation={dropAnimationConfig}>{children}</DragOverlay>
)

SortableOverlay.propTypes = {
    children: PropTypes.node.isRequired,
}

export default SortableOverlay